export default "__VITE_ASSET__U7SUL6UE__"